module.exports = __webpack_public_path__ + "img/online02.9b39b774.png";